import { httpGet, httpPost, httpPut } from "../../utils/httpMethods";
import axios from "axios";
import { PERSONA_URL } from "../restEndpoint";

// Get all personas
export const getAllPersonas = async () => {
  return await httpGet({ url: PERSONA_URL })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err?.response;
    });
};

// Get a single persona by ID
export const getPersonaById = async (personaId) => {
  return await httpGet({ url: `${PERSONA_URL}/${personaId}` })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err?.response;
    });
};

// Create a new persona
export const createPersona = async (personaData) => {
  return await httpPost({ url: PERSONA_URL, payload: personaData })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err?.response;
    });
};

// Update an existing persona
export const updatePersona = async (personaId, personaData) => {
  return await httpPut({ url: `${PERSONA_URL}/${personaId}`, payload: personaData })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err?.response;
    });
};

// Delete a persona - using direct axios with token like modelServices.js
export const deletePersona = async (personaId) => {
  const authUser = JSON.parse(localStorage.getItem("user"));
  const headers = authUser?.token ? { Authorization: `Bearer ${authUser.token}` } : {};
  return await axios.delete(`${PERSONA_URL}/${personaId}`, { headers })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err?.response;
    });
};

// Activate a persona for a conversation
export const activatePersona = async (threadId, personaId) => {
  return await httpPost({ 
    url: `${PERSONA_URL}/conversations/${threadId}/persona/activate`, 
    payload: { persona_id: personaId } 
  })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err?.response;
    });
};

// Deactivate a persona for a conversation
export const deactivatePersona = async (threadId) => {
  return await httpPost({ 
    url: `${PERSONA_URL}/conversations/${threadId}/persona/deactivate`,
    payload: {} 
  })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err?.response;
    });
};